import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

function RelatorioProjetos() {
  const { id } = useParams();
  const [relatorio, setRelatorio] = useState("");
  const [dataRelatorio, setDataRelatorio] = useState("");
  const [status, setStatus] = useState("");
  const [etapa, setEtapa] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!etapa) {
      alert("Selecione a etapa antes de enviar o relatório!");
      return;
    }

    try {
      const token = localStorage.getItem("Token");
      if (!token) {
        alert("Usuário não autenticado");
        return;
      }

      const novoRelatorio = {
        projeto_id: id,
        etapa: etapa,
        situacao_etapa: status,
        observacao: relatorio,
        data_obs: dataRelatorio,
      };

      const response = await axios.post(
        "/api/relatorios",
        novoRelatorio,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.Status === "Success") {
        alert("Relatório enviado com sucesso!");
        setRelatorio("");
        setDataRelatorio("");
        setStatus("");
        setEtapa("");
        navigate(`/viewprojetocompleto/${id}`);
      } else {
        alert("Erro ao enviar relatório");
      }
    } catch (err) {
      console.error(err);
      alert("Erro no envio do relatório");
    }
  };

  return (
    <div className="div-caixa-relatorio">
      <div className="caixa-relatorio">
        <h2>Relatório de Projetos (ID: {id})</h2>
        <form onSubmit={handleSubmit} className="form-relatorio">
          <label htmlFor="relatorio">Escreva o relatório:</label>
          <textarea
            id="relatorio"
            name="relatorio"
            placeholder="Digite seu relatório..."
            value={relatorio}
            onChange={(e) => setRelatorio(e.target.value)}
          />
          <label htmlFor="data_relatorio">Data do Relatório:</label>
          <input
            type="date"
            id="data_relatorio"
            name="data_relatorio"
            value={dataRelatorio}
            onChange={(e) => setDataRelatorio(e.target.value)}
          />
          <label htmlFor="status">Situação do prazo:</label>
          <select
            id="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="" disabled hidden>
              Selecione a situação
            </option>
            <option value="em-andamento">Em andamento</option>
            <option value="atrasado">Atrasado</option>
            <option value="concluido-prazo">Concluído no prazo</option>
            <option value="concluido-fora-prazo">
              Concluído fora do prazo
            </option>
          </select>

          <label htmlFor="etapa">Selecione a etapa</label>
          <select
            id="etapa"
            value={etapa}
            onChange={(e) => setEtapa(e.target.value)}
          >
            <option value="" disabled hidden>
              Selecione a etapa
            </option>
            <option value="1 - Estruturação do projeto">
              1 - Estruturação do projeto
            </option>
            <option value="2 - Elaboração do projeto e orçamento">
              2 - Elaboração do projeto e orçamento
            </option>
            <option value="3 - Processo licitatório">
              3 - Processo licitatório
            </option>
            <option value="4 - Assinatura do contrato">
              4 - Assinatura do contrato
            </option>
            <option value="5 - Acompanhamento contratual">
              5 - Acompanhamento contratual
            </option>
            <option value="6 - Prestação de contas e lições aprendidas">
              6 - Prestação de contas e lições aprendidas
            </option>
          </select>
          <button type="submit">Enviar</button>
        </form>
      </div>
    </div>
  );
}

export default RelatorioProjetos;
